import React from "react";
import Button from "react-bootstrap/Button";
import "./style.scss";

const Modal = (props) => {
  const {
    title,
    children,
    saveButtonText,
    closeButtonText,
    handleCancel,
    handleDelete,
    handleSave,
    saveButtonClass,
    size,
    sectionName,
    bodyClass,
    rootClass,
    isSaveBtnDisabled,
    deleteButtonText,
  } = props;
  return (
    <div
      className={`modal modal-root ${rootClass ? rootClass : ""}`}
      tabIndex="-1"
      data-bs-backdrop="static"
      role="dialog"
    >
      <div
        className={`modal-dialog modal-dialog-centered modal-${size} modal-root__parent ${title === "Info alert" ? "modal-dialog-scrollable" : ""}`}
      >
        <div className="modal-content modal-root__parent__content">
          <div className="modal-header modal-root__parent__content__header">
            <h5 className="modal-title modal-root__parent__content__header__title">
              {title}
              <span className="section-name">{sectionName ? " - " + sectionName.trim() : ""}</span>
            </h5>
            <Button
              className="btn-close modal-root__parent__content__header__btn"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleCancel}
            ></Button>
          </div>
          <div className={`modal-body modal-root__parent__content__body ${bodyClass}`}>{children}</div>
          {(closeButtonText || saveButtonText) && (
            <div className="modal-footer modal-root__parent__content__footer">
              {deleteButtonText && (
                <span className="btn-delete" onClick={handleDelete}>
                  Delete
                </span>
              )}
              <Button variant="outline-primary" onClick={handleCancel}>
                <span>{closeButtonText}</span>
              </Button>
              {saveButtonText != null && saveButtonText !== "" && (
                <Button className={saveButtonClass || ""} onClick={handleSave} disabled={isSaveBtnDisabled}>
                  <span>{saveButtonText}</span>
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Modal;
